import { getCarrierList } from '@/store/locale';
// 格式化航班数据
export const formatFlight = (flightList: any, personNum: any, airports: any) => {
	const lang = window.location.pathname.split('/')[1];
	const carrierAllList = getCarrierList().map((airlineItem: any) => {
		return {
			airlineCode2: airlineItem.airlineCode2,
			airlineCode3: airlineItem.airlineCode3,
			airlineLogo: airlineItem.airlineLogo,
			airlineNameShow: airlineItem['airlineName' + lang],
			airlineNameCn: airlineItem.airlineNameCn,
			airlineNameEn: airlineItem.airlineNameEn,
			airlineNameHk: airlineItem.airlineNameHk,
			airlineNameJa: airlineItem.airlineNameJa,
			airlineNameKo: airlineItem.airlineNameKo,
		};
	});
	const originAirports = JSON.parse(JSON.stringify(airports));
	airports = airports.map((airportItem: any) => {
		return {
			airportCode: airportItem.airportCode,
			airportNameShow: airportItem['airportName' + lang],
			airportNameCn: airportItem.airportNameCn,
			airportNameEn: airportItem.airportNameEn,
			airportNameHk: airportItem.airportNameHk,
			airportNameJa: airportItem.airportNameJa,
			cityCode: airportItem.cityCode,
			cityNameShow: airportItem['cityName' + lang],
			cityNameCn: airportItem.cityNameCn,
			cityNameEn: airportItem.cityNameEn,
			cityNameHk: airportItem.cityNameHk,
			cityNameJa: airportItem.cityNameJa,
			countryCode: airportItem.countryCode,
			countryNameShow: airportItem['countryName' + lang],
		};
	});
	if (carrierAllList.length === 0) {
		return;
	}
	// piniaStore.setAirportsInfo(airports);
	const newList = JSON.parse(JSON.stringify(flightList));
	const newResultList: any = [];
	let depSegments: any = [];
	let arrSegments: any = [];
	let retDepSegments: any = [];
	let retArrSegments: any = [];
	let durationMin: any = false;
	let durationMax: any = false;
	let priceMin: number = 0; //最便宜的最低价格
	let priceMax: number = 0;
	let fromDurationMin: any = false;
	let fromDurationMax: any = false;
	let retDurationMax: any = false;
	let retDurationMin: any = false;
	let durationMinPrice: number = 0; //最快的最低价格
	// const recommendMinPrice: number = 0;
	const stopsList: number[] = [0, 0, 0, 0];
	const priceList: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0];
	const depTimeList: number[] = [0, 0, 0, 0, 0, 0, 0, 0]; //出发时间
	const arrTimeList: number[] = [0, 0, 0, 0, 0, 0, 0, 0]; //出发时间
	const carrierList: any[] = []; //航司
	const connectionList: any[] = []; //中转城市
	const depArrCityList: any = []; //出发地到达地集合
	let depMinPrice: number = 0;

	for (let i = 0, len = newList.length; i < len; i++) {
		newList[i].fromStops = 0;
		newList[i].stops = 0;
		newList[i].retStops = 0;
		newList[i].duration = 0;
		newList[i].durationFrom = 0;
		newList[i].showPrice = 0;
		newList[i].durationRet = 0;
		newList[i].carriers = [];
		newList[i].carriersFrom = [];
		newList[i].carriersRet = [];
		newList[i].fromStopCity = [];
		newList[i].retStopCity = [];
		newList[i].showFromSegmentArray = [];
		newList[i].showRetSegmentArray = [];
		newList[i].fromTimeLine = [];
		newList[i].retTimeLine = [];
		// 去除没有在航司列表出现的航司
		let isContinueShowCarrier = true;
		const {
			childPrice,
			childTax,
			adultPrice,
			adultTax,
			infantPrice,
			infantTax,
		} = newList[i];
		newList[i].showPrice =
			(Number(personNum.adultNum > 0 ? (Number(adultPrice) + Number(adultTax)) * Number(personNum.adultNum) : 0) +
				Number(personNum.childNum > 0 ? (Number(childPrice) + Number(childTax)) * Number(personNum.childNum) : 0) +
				Number(personNum.infantNum > 0 ? (Number(infantPrice) + Number(infantTax)) * Number(personNum.infantNum) : 0)) /
			(Number(personNum.adultNum) +
				Number(personNum.childNum) +
				Number(personNum.infantNum));

		const priceGear = Math.floor(newList[i].showPrice / 5000);
		priceList[priceGear]++;
		for (let j = 0, leng = newList[i].fromSegments.length; j < leng; j++) {

			if (!getCarrierInfo(newList[i].fromSegments[j].carrier, carrierAllList)) {
				isContinueShowCarrier = false;
				continue;
			}

			newList[i].fromSegments[j].showDepCity = getCityInfo(newList[i].fromSegments[j].depAirport, airports);
			newList[i].fromSegments[j].showArrCity = getCityInfo(newList[i].fromSegments[j].arrAirport, airports);
			newList[i].fromSegments[j].isTransit = false; //是否中转
			newList[i].fromSegments[j].isTransitTime = ''; //中转时间
			newList[i].fromSegments[j].depTime = formatTime(newList[i].fromSegments[j].depTime);
			newList[i].fromSegments[j].arrTime = formatTime(newList[i].fromSegments[j].arrTime);
			newList[i].fromSegments[j].segmentDayPlus = getDateByDays(newList[i].fromSegments[j].depTime.substr(0, 10), newList[i].fromSegments[j].arrTime.substr(0, 10));

			const carrierInfo = getCarrierInfo(newList[i].fromSegments[j].carrier, carrierAllList);
			newList[i].duration = newList[i].duration + newList[i].fromSegments[j].duration;
			if (j > 0) {
				let waitTime =
					new Date(newList[i].fromSegments[j].depTime).getTime() -
					new Date(newList[i].fromSegments[j - 1].arrTime).getTime();
				waitTime = waitTime / 60000;
				newList[i].fromTimeLine.push({
					beforeTime: newList[i].durationFrom,
					showCity: newList[i].fromSegments[j].showDepCity,
					time: waitTime * 1
				});
				newList[i].duration = newList[i].duration * 1 + waitTime * 1;
				newList[i].durationFrom = newList[i].durationFrom * 1 + waitTime * 1;
			}
			newList[i].durationFrom =
				newList[i].durationFrom * 1 + newList[i].fromSegments[j].duration * 1;
			carrierInfo.showPrice = newList[i].showPrice;
			if (depMinPrice == 0) {
				depMinPrice = newList[i].showPrice;
			}
			newList[i].fromSegments[j].carrierInfo = carrierInfo;
			if (newList[i].carriersFrom.length === 0) {
				newList[i].carriersFrom.push(carrierInfo);
			} else {
				let carrierPushed = false;
				for (let h in newList[i].carriersFrom) {
					if (newList[i].carriersFrom[h].airlineCode2 === carrierInfo.airlineCode2) {
						carrierPushed = true;
					}
				}
				if (!carrierPushed) {
					newList[i].carriersFrom.push(carrierInfo);
				}
			}
			// 乘机时间
			newList[i].fromSegments[j].showDuration = formatDuration(newList[i].fromSegments[j].duration);
			newList[i].fromSegments[j].showDepTime = newList[i].fromSegments[j].depTime.substr(11, 5);
			newList[i].fromSegments[j].showArrTime = newList[i].fromSegments[j].arrTime.substr(11, 5);
			newList[i].fromSegments[j].showStops = formatStops(newList[i].fromSegments[j].stopCities, airports);
			newList[i].carriers.push(carrierInfo);
			const carrierResult = judgeCarrier(
				newList[i].fromSegments[j].carrier,
				carrierList,
				newList[i].showPrice
			);
			if (carrierResult[0] == 0) {
				carrierList.push(carrierInfo);
			} else if (carrierResult[0] == 1) {
				carrierList[carrierResult[1]].showPrice = newList[i].showPrice;
			}
			if (newList[i].fromSegments[j].stopCities != '') {
				newList[i].stops =
					newList[i].stops + newList[i].fromSegments[j].stopCities.split(',').length;
				newList[i].fromStops =
					newList[i].fromStops + newList[i].fromSegments[j].stopCities.split(',').length;
			}
			if (j > 0) {
				newList[i].fromSegments[j].isTransit = newList[i].fromSegments[j - 1].showArrCity;
				if (!newList[i].fromSegments[j].isTransit) {
					newList[i].fromSegments[j].isTransit = {
						airportCode: newList[i].fromSegments[j].arrAirport,
						airportNameCn: newList[i].fromSegments[j].showArrCity['airportNameCn'],
						airportNameEn: newList[i].fromSegments[j].showArrCity['airportNameEn'],
						airportNameHk: newList[i].fromSegments[j].showArrCity['airportNameHk'],
						airportNamePy: newList[i].fromSegments[j].showArrCity['airportNamePy'],
						cityCode: newList[i].fromSegments[j].showArrCity.cityCode,
						cityNameCn: newList[i].fromSegments[j].showArrCity['cityNameCn'],
						cityNameEn: newList[i].fromSegments[j].showArrCity['cityNameEn'],
						cityNameHk: newList[i].fromSegments[j].showArrCity['cityNameHk'],
						cityNamePy: newList[i].fromSegments[j].showArrCity['cityNamePy'],

						countryCode: newList[i].fromSegments[j].showArrCity.countryCode,
						countryNameCn: newList[i].fromSegments[j].showArrCity.countryNameCn,
						countryNameEn: newList[i].fromSegments[j].showArrCity.countryNameEn,
						countryNameHk: newList[i].fromSegments[j].showArrCity.countryNameHk,
						countryTel: null,
						isCity: newList[i].fromSegments[j].showArrCity.isCity,
						price: newList[i].showPrice
					};
				}
				newList[i].fromSegments[j].isTransit.price = newList[i].showPrice;
				if (newList[i].fromSegments[j].isTransit) {
					if (connectionList.findIndex(
						(item: any) => item.airportCode === newList[i].fromSegments[j].isTransit.airportCode
					) == -1) {
						connectionList.push({
							...newList[i].fromSegments[j].isTransit,
							price: newList[i].showPrice
						});
					} else {
						connectionList.forEach((item, ind) => {
							if (newList[i].fromSegments[j].isTransit.airportCode == item.airportCode && item.price > newList[i].showPrice) {
								connectionList[ind].price = newList[i].showPrice;
							}
						});
					}
				}

				// const connectionResult = judgeConnection(
				//   newList[i].fromSegments[j].isTransit.airportCode,
				//   connectionList,
				//   newList[i].showPrice
				// );
				// if (connectionResult[0] == 0) {
				//   connectionList.push(newList[i].fromSegments[j].isTransit);
				// } else if (connectionResult[0] == 1) {
				//   connectionList[i].price = newList[i].showPrice;
				// }
			}
			if (j > 0) {
				newList[i].fromSegments[j].isTransitTime = calculateTime(
					newList[i].fromSegments[j - 1].arrTime,
					newList[i].fromSegments[j].depTime
				);
				newList[i].showFromSegmentArray.push({
					type: 5, //1.起始出发2.中间出发3.最终到达4.中间到达5.中转信息6.飞行信息
					cityInfo: {},
					showDuration: newList[i].fromSegments[j].isTransitTime,
					isOverNight: false,
					airModel: '',
					serviceContent: '',
					attentionPoints: '',
				});
			}
			newList[i].showFromSegmentArray.push({
				type: j == 0 ? 1 : 2, //1.起始出发2.中间出发3.最终到达4.中间到达5.中转信息6.飞行信息
				cityInfo: newList[i].fromSegments[j].showDepCity,
				showDuration: newList[i].fromSegments[j].showDepTime,
				flightNumber: newList[i].fromSegments[j].flightNumber,
				isOverNight: false,
				airModel: '',
				serviceContent: '',
				attentionPoints: '',
			});
			newList[i].showFromSegmentArray.push({
				type: 6, //1.起始出发2.中间出发3.最终到达4.中间到达5.中转信息6.飞行信息
				cityInfo: {},
				showDuration: newList[i].fromSegments[j].showDuration,
				isOverNight: newList[i].fromSegments[j].depTime.substr(0, 10) !== newList[i].fromSegments[j].arrTime.substr(0, 10),
				airModel: newList[i].fromSegments[j].airModel,
				serviceContent: '',
				attentionPoints: '',
				duration: newList[i].fromSegments[j].duration,
				flightNumber: newList[i].fromSegments[j].flightNumber,
				bagg_num: newList[i].fromSegments[j].bagg_num,
				bagg_unit: newList[i].fromSegments[j].bagg_unit
			});
			newList[i].showFromSegmentArray.push({
				type: j == newList[i].fromSegments.length - 1 ? 3 : 4,
				cityInfo: newList[i].fromSegments[j].showArrCity,
				showDuration: newList[i].fromSegments[j].showArrTime,
				segmentDayPlus: newList[i].fromSegments[j].segmentDayPlus,
				isOverNight: false,
				airModel: '',
				serviceContent: '',
				attentionPoints: '',
			});
		}
		if (isContinueShowCarrier) {
			newList[i].fromStops = newList[i].fromStops + (newList[i].fromSegments.length - 1);
			//航程部分信息可在航段循环后直接使用
			depSegments = newList[i].fromSegments[0];
			arrSegments = newList[i].fromSegments[newList[i].fromSegments.length - 1];
			newList[i].depDate = depSegments.depTime.substr(0, 10);
			newList[i].depWeekDay = new Date(depSegments.depTime).getDay();
			newList[i].depTime = depSegments.depTime.substr(11, 5);
			newList[i].arrDate = arrSegments.arrTime.substr(0, 10);
			newList[i].arrTime = arrSegments.arrTime.substr(11, 5);
			newList[i].depCityInfo = depSegments.showDepCity;
			newList[i].arrCityInfo = arrSegments.showArrCity;
			newList[i].fromDayPlus = getDateByDays(newList[i].depDate, newList[i].arrDate);

			if (
				depArrCityList.findIndex(
					(item: any) => item.airportCode === newList[i].depCityInfo.airportCode
				) == -1
			) {
				if (depMinPrice > newList[i].showPrice) {
					depMinPrice = newList[i].showPrice;
				}
				depArrCityList.push(
					Object.assign(newList[i].depCityInfo, { depMinPrice: depMinPrice, checked: false })
				);
			} else {
				if (depMinPrice > newList[i].showPrice) {
					depMinPrice = newList[i].showPrice;
				}
				depArrCityList[
					depArrCityList.findIndex(
						(item: any) => item.airportCode === newList[i].depCityInfo.airportCode
					)
				].depMinPrice = depMinPrice;
			}
			if (
				depArrCityList.findIndex(
					(item: any) => item.airportCode === newList[i].arrCityInfo.airportCode
				) == -1
			) {
				if (depMinPrice > newList[i].showPrice) {
					depMinPrice = newList[i].showPrice;
				}
				depArrCityList.push(
					Object.assign(newList[i].arrCityInfo, { depMinPrice: depMinPrice, checked: false })
				);
			} else {
				if (depMinPrice > newList[i].showPrice) {
					depMinPrice = newList[i].showPrice;
				}
				depArrCityList[
					depArrCityList.findIndex(
						(item: any) => item.airportCode === newList[i].arrCityInfo.airportCode
					)
				].depMinPrice = depMinPrice;
			}
		}
		if (isContinueShowCarrier) {
			for (let j = 0, leng = newList[i].retSegments.length; j < leng; j++) {
				if (!getCarrierInfo(newList[i].retSegments[j].carrier, carrierAllList)) {
					isContinueShowCarrier = false;
					continue;
				}
				newList[i].retSegments[j].showDepCity = getCityInfo(newList[i].retSegments[j].depAirport, airports);
				newList[i].retSegments[j].showArrCity = getCityInfo(newList[i].retSegments[j].arrAirport, airports);
				newList[i].retSegments[j].isTransit = false; //是否中转
				newList[i].retSegments[j].isTransitTime = ''; //中转时间
				newList[i].retSegments[j].depTime = formatTime(newList[i].retSegments[j].depTime);
				newList[i].retSegments[j].arrTime = formatTime(newList[i].retSegments[j].arrTime);
				newList[i].retSegments[j].segmentDayPlus = getDateByDays(newList[i].retSegments[j].depTime.substr(0, 10), newList[i].retSegments[j].arrTime.substr(0, 10));
				const carrierInfo = getCarrierInfo(newList[i].retSegments[j].carrier, carrierAllList);
				newList[i].duration = newList[i].duration * 1 + newList[i].retSegments[j].duration * 1;
				if (j > 0) {
					let waitTime =
						new Date(newList[i].retSegments[j].depTime).getTime() -
						new Date(newList[i].retSegments[j - 1].arrTime).getTime();
					waitTime = waitTime / 60000;
					newList[i].retTimeLine.push({
						beforeTime: newList[i].durationRet,
						showCity: newList[i].retSegments[j].showDepCity,
						time: waitTime * 1
					});
					newList[i].duration = newList[i].duration * 1 + waitTime * 1;
					newList[i].durationRet = newList[i].durationRet * 1 + waitTime * 1;
				}
				newList[i].durationRet = newList[i].durationRet + newList[i].retSegments[j].duration;
				carrierInfo.showPrice = newList[i].showPrice;
				newList[i].retSegments[j].carrierInfo = carrierInfo;

				if (newList[i].carriersRet.length === 0) {
					newList[i].carriersRet.push(carrierInfo);
				} else {
					let carrierPushed = false;
					for (let h in newList[i].carriersRet) {
						if (newList[i].carriersRet[h].airlineCode2 === carrierInfo.airlineCode2) {
							carrierPushed = true;
						}
					}
					if (!carrierPushed) {
						newList[i].carriersRet.push(carrierInfo);
					}
				}
				newList[i].retSegments[j].showDuration = formatDuration(newList[i].retSegments[j].duration);
				newList[i].retSegments[j].showDepTime = newList[i].retSegments[j].depTime.substr(11, 5);
				newList[i].retSegments[j].showArrTime = newList[i].retSegments[j].arrTime.substr(11, 5);
				newList[i].retSegments[j].showStops = formatStops(newList[i].retSegments[j].stopCities, airports);
				newList[i].carriers.push(carrierInfo);
				if (newList[i].retSegments[j].stopCities != '') {
					newList[i].stops = newList[i].stops + newList[i].retSegments[j].stopCities.split(',').length;
					newList[i].retStops =
						newList[i].retStops + newList[i].retSegments[j].stopCities.split(',').length;
				}
				const carrierResult = judgeCarrier(
					newList[i].retSegments[j].carrier,
					carrierList,
					newList[i].showPrice
				);
				if (carrierResult[0] === 0) {
					carrierList.push(carrierInfo);
				} else if (carrierResult[0] === 1) {
					carrierList[carrierResult[1]].showPrice = newList[i].showPrice;
				}
				if (j > 0) {
					newList[i].retSegments[j].isTransit = newList[i].retSegments[j - 1].showArrCity;
					if (!newList[i].retSegments[j].isTransit) {
						newList[i].retSegments[j].isTransit = {
							airportCode: newList[i].retSegments[j].arrAirport,
							airportNameCn: newList[i].retSegments[j].showArrCity['airportNameCn'],
							airportNameEn: newList[i].retSegments[j].showArrCity['airportNameEn'],
							airportNameHk: newList[i].retSegments[j].showArrCity['airportNameHk'],
							airportNamePy: newList[i].retSegments[j].showArrCity['airportNamePy'],
							cityCode: newList[i].retSegments[j].showArrCity.cityCode,
							cityNameCn: newList[i].retSegments[j].showArrCity['cityNameCn'],
							cityNameEn: newList[i].retSegments[j].showArrCity['cityNameEn'],
							cityNameHk: newList[i].retSegments[j].showArrCity['cityNameHk'],
							cityNamePy: newList[i].retSegments[j].showArrCity['cityNamePy'],
							countryCode: newList[i].retSegments[j].showArrCity.countryCode,
							countryNameCn: newList[i].retSegments[j].showArrCity.countryNameCn,
							countryNameEn: newList[i].retSegments[j].showArrCity.countryNameEn,
							countryNameHk: newList[i].retSegments[j].showArrCity.countryNameHk,
							countryTel: null,
							isCity: newList[i].retSegments[j].showArrCity.isCity,
							price: newList[i].showPrice
						};
					}
					newList[i].retSegments[j].isTransit.price = newList[i].showPrice;
					if (newList[i].retSegments[j].isTransit) {
						if (connectionList.findIndex(
							(item: any) => item.airportCode === newList[i].retSegments[j].isTransit.airportCode
						) === -1) {
							connectionList.push({
								...newList[i].retSegments[j].isTransit,
								price: newList[i].showPrice
							});
						} else {
							connectionList.forEach((item, ind) => {
								if (item.airportCode === newList[i].retSegments[j].isTransit.airportCode && item.price > newList[i].showPrice) {
									connectionList[ind].price = newList[i].showPrice;
								}
							});
						}
					}
				}
				if (j > 0) {
					newList[i].retSegments[j].isTransitTime = calculateTime(
						newList[i].retSegments[j - 1].arrTime,
						newList[i].retSegments[j].depTime
					);
					newList[i].showRetSegmentArray.push({
						type: 5, //1.起始出发2.中间出发3.最终到达4.中间到达5.中转信息6.飞行信息
						cityInfo: {},
						showDuration: newList[i].retSegments[j].isTransitTime,
						isOverNight: false,
						airModel: '',
						serviceContent: '',
						attentionPoints: '',
					});
				}
				newList[i].showRetSegmentArray.push({
					type: j === 0 ? 1 : 2, //1.起始出发2.中间出发3.最终到达4.中间到达5.中转信息6.飞行信息
					cityInfo: newList[i].retSegments[j].showDepCity,
					showDuration: newList[i].retSegments[j].showDepTime,
					isOverNight: false,
					airModel: '',
					flightNumber: newList[i].retSegments[j].flightNumber,
					serviceContent: '',
					attentionPoints: '',
				});
				newList[i].showRetSegmentArray.push({
					type: 6, //1.起始出发2.中间出发3.最终到达4.中间到达5.中转信息6.飞行信息
					cityInfo: {},
					showDuration: newList[i].retSegments[j].showDuration,
					isOverNight: newList[i].retSegments[j].depTime.substr(0, 10) !== newList[i].retSegments[j].arrTime.substr(0, 10),
					airModel: newList[i].retSegments[j].airModel,
					serviceContent: '',
					attentionPoints: '',
					duration: newList[i].retSegments[j].duration,
					flightNumber: newList[i].retSegments[j].flightNumber,
					bagg_num: newList[i].retSegments[j].bagg_num,
					bagg_unit: newList[i].retSegments[j].bagg_unit
				});
				newList[i].showRetSegmentArray.push({
					type: j === newList[i].retSegments.length - 1 ? 3 : 4,
					cityInfo: newList[i].retSegments[j].showArrCity,
					showDuration: newList[i].retSegments[j].showArrTime,
					flightNumber: newList[i].retSegments[j].flightNumber,
					segmentDayPlus: newList[i].retSegments[j].segmentDayPlus,
					isOverNight: false,
					airModel: '',
					serviceContent: '',
					attentionPoints: '',
				});
			}
		}
		if (isContinueShowCarrier) {
			newList[i].retStops = newList[i].retStops + (newList[i].retSegments.length - 1);
			//返程需要展示的信息
			if (newList[i].retSegments.length > 0) {
				retDepSegments = newList[i].retSegments[0];
				retArrSegments = newList[i].retSegments[newList[i].retSegments.length - 1];
				newList[i].retDepDate = retDepSegments.depTime.substr(0, 10);
				newList[i].retDepWeekDay = new Date(retDepSegments.depTime).getDay();
				newList[i].retDepTime = retDepSegments.depTime.substr(11, 5);
				newList[i].retArrDate = retArrSegments.arrTime.substr(0, 10);
				newList[i].retArrTime = retArrSegments.arrTime.substr(11, 5);
				newList[i].retDepCityInfo = retDepSegments.showDepCity;
				newList[i].retArrCityInfo = retArrSegments.showArrCity;
				newList[i].retDayPlus = getDateByDays(newList[i].retDepDate, newList[i].retArrDate);
				if (
					depArrCityList.findIndex(
						(item: any) => item.airportCode === newList[i].retDepCityInfo.airportCode
					) === -1
				) {
					if (depMinPrice > newList[i].showPrice) {
						depMinPrice = newList[i].showPrice;
					}
					depArrCityList.push(
						Object.assign(newList[i].retDepCityInfo, { depMinPrice: depMinPrice, checked: false })
					);
				} else {
					if (depMinPrice > newList[i].showPrice) {
						depMinPrice = newList[i].showPrice;
					}
					depArrCityList[
						depArrCityList.findIndex(
							(item: any) => item.airportCode === newList[i].retDepCityInfo.airportCode
						)
					].depMinPrice = depMinPrice;
				}
				if (
					depArrCityList.findIndex(
						(item: any) => item.airportCode === newList[i].retArrCityInfo.airportCode
					) === -1
				) {
					if (depMinPrice > newList[i].showPrice) {
						depMinPrice = newList[i].showPrice;
					}
					depArrCityList.push(
						Object.assign(newList[i].retArrCityInfo, { depMinPrice: depMinPrice, checked: false })
					);
				} else {
					if (depMinPrice > newList[i].showPrice) {
						depMinPrice = newList[i].showPrice;
					}
					depArrCityList[
						depArrCityList.findIndex(
							(item: any) => item.airportCode === newList[i].retArrCityInfo.airportCode
						)
					].depMinPrice = depMinPrice;
				}
			}
			//筛选用数组
			if (fromDurationMin === false || fromDurationMin > newList[i].durationFrom) {
				fromDurationMin = newList[i].durationFrom;
			}
			if (!fromDurationMax || fromDurationMax < newList[i].durationFrom) {
				fromDurationMax = newList[i].durationFrom;
			}
			if (retDurationMin === false || retDurationMin > newList[i].durationRet) {
				retDurationMin = newList[i].durationRet;
			}
			if (!retDurationMax || retDurationMax < newList[i].durationRet) {
				retDurationMax = newList[i].durationRet;
			}
			if (durationMin === false || durationMin > newList[i].duration) {
				durationMin = newList[i].duration;
				durationMinPrice = newList[i].showPrice;
			}
			if (!durationMax || durationMax < newList[i].duration) {
				durationMax = newList[i].duration;
			}
			// newList[i].showDuration = formatDuration(newList[i].duration)
			newList[i].showFromDuration = formatDuration(newList[i].durationFrom);
			newList[i].showFromHour = formatDurationHour(newList[i].durationFrom);
			newList[i].showRetDuration = formatDuration(newList[i].durationRet);
			newList[i].showRetHour = formatDurationHour(newList[i].durationRet);
			stopsList[newList[i].stops]++;
			const depTimeGear = Math.floor(newList[i].depTime.substr(0, 2) / 3);
			depTimeList[depTimeGear]++;
			const arrTimeGear = Math.floor(newList[i].arrTime.substr(0, 2) / 3);
			arrTimeList[arrTimeGear]++;
		}
		if (isContinueShowCarrier) {
			newResultList.push(newList[i]);
			if (!priceMin || newList[i].showPrice < priceMin) {
				priceMin = newList[i].showPrice;
			}
			if (!priceMax || newList[i].showPrice > priceMax) {
				priceMax = newList[i].showPrice;
			}
		}
	}
	for (let h = 0, depLen = depTimeList.length; h < depLen; h++) {
		depTimeList[h] = Math.round((depTimeList[h] / newResultList.length) * 50);
	}
	for (let h = 0, arrLen = arrTimeList.length; h < arrLen; h++) {
		arrTimeList[h] = Math.round((arrTimeList[h] / newResultList.length) * 50);
	}
	newResultList.sort((a: any, b: any) => {
		return a.showPrice - b.showPrice;
	});
	//价格区间规则-两侧最低最高，按1000进行分隔，即0-1000-2000-3000-400-5000，六个点
	// 柱状图为0-1000-2000-3000-4000-5000共五个统计柱状
	const returnList: any[] = newResultList;
	return {
		durationMin: durationMin,
		durationMinPrice: durationMinPrice,
		durationMax: durationMax,
		priceMin: priceMin,
		priceMax: priceMax,
		fromDurationMin: fromDurationMin,
		fromDurationMax: fromDurationMax,
		retDurationMin: retDurationMin,
		retDurationMax: retDurationMax,
		flightList: returnList,
		priceList: priceList,
		carrierList: carrierList,
		stopsList: stopsList,
		depTimeList: depTimeList,
		arrTimeList: arrTimeList,
		connectionList: connectionList,
		depArrCityList: depArrCityList,
		allAirports: originAirports
	};
};


function getCityInfo(str: string, airports: any) {
	for (let i = 0, len = airports.length; i < len; i++) {
		if (airports[i].airportCode === str) {
			return airports[i];
		}
	}
}
function getCarrierInfo(str: string, carrierList: any) {
	for (let o = 0; o < carrierList.length; o++) {
		if (carrierList[o].airlineCode2 === str) {
			return {
				...carrierList[o],
				showPrice: 0,
			};
		}
	}
}
export const formatDuration = (duration: number) => {
	const lang = window.location.pathname.split('/')[1];
	if (duration < 60) {
		return 0 + ((lang === 'En' || lang === 'Id') ? 'h' : '时') + duration + ((lang === 'En' || lang === 'Id') ? 'm' : '分');
	} else {
		const hour = Math.floor(duration / 60);
		const minutes = duration - hour * 60;
		return hour + ((lang === 'En' || lang === 'Id') ? 'h' : '时') + minutes + ((lang === 'En' || lang === 'Id') ? 'm' : '分');
	}
};
export const formatDurationHour = (duration: number) => {
	if (duration < 60) {
		return 0;
	} else {
		const hour = Math.floor(duration / 60);
		return hour;
	}
};
function formatStops(citys: string, airports: any) {
	if (citys.length === 0) {
		return [];
	}
	const newList = citys.split('/');
	const returnList = [];
	for (let i = 0; i < airports.length; i++) {
		if (newList.indexOf(airports[i].cityCode) !== -1) {
			returnList.push(airports[i].cityNameEn);
		}
		if (returnList.length === newList.length) {
			break;
		}
	}
	return returnList;
}

function calculateTime(arrTime: string, depTime: string) {
	let duration = new Date(depTime).getTime() - new Date(arrTime).getTime();
	duration = duration / 60000;
	return formatDuration(duration);
}

function judgeCarrier(carrierCode: any, carrierList: any, price: any) {
	//返回值含义 0-不包含1-包含但要修改价格2-包含并且不需要修改价格、及相关位置

	for (let i = 0; i < carrierList.length; i++) {
		if (carrierCode === carrierList[i].airlineCode2) {
			if (price < carrierList[i].showPrice) {
				return [1, i];
			}
			return [2, i];
		}
	}
	return [0, 0];
}
// @ts-ignore
function judgeConnection(connection: any, connectionList: any, price: any) {
	//返回值含义 0-不包含1-包含但要修改价格2-包含并且不需要修改价格、及相关位置

	for (let i = 0; i < connectionList.length; i++) {
		if (connection === connectionList[i].airportCode) {
			if (price < connectionList[i].showPrice) {
				return [1, i];
			}
			return [2, i];
		}
	}
	return [0, 0];
}

export const formatTime = (str: any) => {
	str = str + '00';
	return str.replace(/^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/, '$1/$2/$3 $4:$5:$6');
};

export function formatCity(list: any) {
	for (let i = 0; i < list[1].length; i++) {
		for (let j = 0; j < list[0].length; j++) {
			if (list[1][i].cityCode === list[0][j].cityCode) {
				if (!list[0][j].airportList) {
					list[0][j].airportList = [];
				}
				list[0][j].airportList.push(list[1][i]);
				break;
			}
		}
	}
	return list[0];
}

export function formatCityAll(list: any) {
	const countryList: any[] = [];
	const cityListObj: any = {};
	const cityListAirport: any[] = [];
	const airportListArr: any[] = [];
	for (let i = 0; i < list.length; i++) {
		let inCountryList = false;
		//循环判断是否在国家列表中
		for (let j = 0; j < countryList.length; j++) {
			if (countryList[j].countryCode === list[i].countryCode) {
				inCountryList = true;
			}
		}
		if (!inCountryList && list[i].countryCode) {
			countryList.push({
				countryCode: list[i].countryCode,
				countryNameCn: list[i].countryNameCn,
				countryNameEn: list[i].countryNameEn,
				countryNameHk: list[i].countryNameHk
			});
		}

		let inCityListAirport = false;
		for (let j = 0; j < cityListAirport.length; j++) {
			if (list[i].cityCode === cityListAirport[j].cityCode) {
				inCityListAirport = true;
				cityListAirport[j].airportList.push(list[i]);
				break;
			}
		}
		if (!inCityListAirport) {
			cityListAirport.push({
				cityCode: list[i].cityCode,
				cityNameCn: list[i].cityNameCn,
				cityNameEn: list[i].cityNameEn,
				cityNameHk: list[i].cityNameHk,
				cityNamePy: list[i].cityNamePy,
				airportList: [list[i]]
			});
		}

		if (!inCityListAirport) {
			cityListObj[list[i].cityCode] = {
				cityCode: list[i].cityCode,
				cityNameCn: list[i].cityNameCn,
				cityNameEn: list[i].cityNameEn,
				cityNameHk: list[i].cityNameHk,
				cityNamePy: list[i].cityNamePy
			};
		}
	}
	return {
		cityListObj,
		countryList,
		cityListAirport,
		airportListArr
	};
}
function getDateByDays(startDate: any, endDdate: any) {
	// @ts-ignore
	const d1: any = Date.parse(new Date(startDate));
	// @ts-ignore
	const d2: any = Date.parse(new Date(endDdate));
	// 时间戳相减 / 天数
	// @ts-ignore
	const day = parseInt((d2 - d1) / (1000 * 60 * 60 * 24));
	return day;
}
// 获取日期以及星期
export const dateWeekDayConvert = (date: string, t: any, isShowWeek: boolean) => {
	const monthDay = (new Date(date).getMonth() + 1) + t('order.yue') + new Date(date).getDate() + t('order.ri');
	const wekDays = [t('detail.xingqi0'), t('detail.xingqi1'), t('detail.xingqi2'), t('detail.xingqi3'), t('detail.xingqi4'), t('detail.xingqi5'), t('detail.xingqi6')];
	const weekDay = wekDays[new Date(date).getDay()];
	if (isShowWeek) {
		return monthDay + ' ' + weekDay;
	} else {
		return monthDay + ' ';
	}
};
// 获取分秒
export const formatDurationSecond = (duration: number, t: any) => {
	if (duration < 60) {
		return duration + t('order.miao');
	} else {
		const hour = Math.floor(duration / 60);
		const minutes = duration - hour * 60;
		return hour + t('order.fen') + minutes + t('order.miao');
	}
};